module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/related/en/5-b3cbf61c1c3de02006fe1c8794123944.jpg";